import { c as _c } from "react/compiler-runtime";
import SlotSheetOverLay from "../calendar/common/slot-sheet-overlay";
import Main from "../calendar/slot-visit/main";
import { type Slot } from "../calendar/slot-visit/types";
interface VisitSchedulingOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  unitId?: string;
  projectId?: string;
  userId?: string;
  buyerId?: string;
  propertyName?: string;
  onScheduleComplete?: (slots: {
    start: string;
    end: string;
  }[]) => void;
}
export function VisitSchedulingOverlay(t0) {
  const $ = _c(15);
  const {
    isOpen,
    onClose,
    unitId,
    projectId,
    userId,
    buyerId,
    onScheduleComplete
  } = t0;
  let t1;
  if ($[0] !== onClose || $[1] !== onScheduleComplete) {
    t1 = slots => {
      const formattedSlots = slots.map(_temp);
      onScheduleComplete?.(formattedSlots);
      onClose();
    };
    $[0] = onClose;
    $[1] = onScheduleComplete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleScheduleVisit = t1;
  if (!isOpen) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm text-gray-600 mt-1">Please select at least 4 slots</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = userId || "";
  const t4 = buyerId || "";
  let t5;
  if ($[4] !== handleScheduleVisit || $[5] !== onClose || $[6] !== projectId || $[7] !== t3 || $[8] !== t4 || $[9] !== unitId) {
    t5 = <div className="flex-1 h-[80dvh] overflow-y-auto pt-4 pl-4 pr-4 pb-0">{t2}<Main onChange={handleScheduleVisit} setLoading={_temp2} unitId={unitId} userId={t3} projectId={projectId} buyerId={t4} minSlots={4} className="h-auto! flex-1 " onClick={onClose} /></div>;
    $[4] = handleScheduleVisit;
    $[5] = onClose;
    $[6] = projectId;
    $[7] = t3;
    $[8] = t4;
    $[9] = unitId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isOpen || $[12] !== onClose || $[13] !== t5) {
    t6 = <SlotSheetOverLay header="Schedule Visit" isOpen={isOpen} onClose={onClose}>{t5}</SlotSheetOverLay>;
    $[11] = isOpen;
    $[12] = onClose;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp2() {}
function _temp(t0) {
  const {
    start,
    end
  } = t0;
  return {
    start: typeof start === "string" ? start : start.toISOString(),
    end: typeof end === "string" ? end : end.toISOString()
  };
}